import { useMutation } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { IRQCallbacks } from '../../types/my-types';

export const useExtractionBatchClean = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (extractionBatchId: string) =>
      await (await glynt).extractionBatch.clean(extractionBatchId),

    ...callbacks
  });
};
